export enum SettingsActionTypes {
  FETCH_SETTINGS = "@@SETTINGS/FETCH_SETTINGS",
  FETCH_SETTINGS_SUCCESS = "@@SETTINGS/FETCH_SETTINGS_SUCCESS",
  FETCH_SETTINGS_FAILURE = "@@SETTINGS/FETCH_SETTINGS_FAILURE",

  SAVE_SETTINGS = "@@SETTINGS/SAVE_SETTINGS",
  SAVE_SETTINGS_SUCCESS = "@@SETTINGS/SAVE_SETTINGS_SUCCESS",
  SAVE_SETTINGS_FAILURE = "@@SETTINGS/SAVE_SETTINGS_FAILURE",
}
